const {component, dom, svg} = require('../odo/odojs/')
const inject = require('injectinto');

inject.bind('page:error', component({
  render: function(state, params) {
    return dom('.page--wrapper', [
      dom('nav',
      [
        dom('a.nav--logo',
        {
          attributes: {
            href: '/',
            rel: 'external'
          }
        },
        svg('svg',
        {},
        svg('use',
        {
          'xlink:href': '/assets.svg#logo-horizontal'
        })))
      ]),
      dom('hr'),
      dom('.page--content',
      [dom('p',
      params.page.message),
      dom('p',
      params.page.details)]),
      dom('hr.secondary'),
      dom('footer',
      [
        dom('ul',
        [
          dom('li',
          dom('a',
          {
            attributes: {
              href: '/contact',
              rel: 'external'
            }
          },
          'Contact Us'))
        ])
      ])
    ]);
  }
}));
